import React, { useEffect, useState } from "react";
import { FaUserFriends } from "react-icons/fa";
import API_BASE_URL from "../config/api";
import "./RightPopup.css";

export default function RightPopup() {
  const [count, setCount] = useState(0);

  useEffect(() => {

    const fetchLiveUsers = () => {
      fetch(`${API_BASE_URL}/get_live_users.php`)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setCount(data.count);
          }
        })
        .catch(err => console.log("Live user fetch error", err));
    };

    fetchLiveUsers();  

    const interval = setInterval(fetchLiveUsers, 30000); // refresh every 30 sec

    return () => clearInterval(interval);

  }, []);

  return (
    <div className="right-badge">
      <FaUserFriends className="badge-icon" />
      <span className="badge-count">{count}</span>
    </div>
  );
}